module.exports = __webpack_public_path__ + "static/media/mac88-virtual.d70f698b.webp";